/**
 * @generated SignedSource<<5fae42ab53aed5efd1bfa438dde32a69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useEliteSeatProgressUpdatedAllLevelsQuery$variables = {};
export type useEliteSeatProgressUpdatedAllLevelsQuery$data = {
  readonly eliteSealLevels: ReadonlyArray<{
    readonly name: string;
    readonly tierStartUsd: number;
    readonly tierStartLevel: number;
    readonly tierStep: number;
    readonly tierCount: number;
    readonly bonusUsd: ReadonlyArray<number>;
  }>;
};
export type useEliteSeatProgressUpdatedAllLevelsQuery = {
  variables: useEliteSeatProgressUpdatedAllLevelsQuery$variables;
  response: useEliteSeatProgressUpdatedAllLevelsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EliteSeatLevel",
    "kind": "LinkedField",
    "name": "eliteSealLevels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tierStartUsd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tierStartLevel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tierStep",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tierCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bonusUsd",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useEliteSeatProgressUpdatedAllLevelsQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useEliteSeatProgressUpdatedAllLevelsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b82c805ed001223578c43931b07deec2",
    "id": null,
    "metadata": {},
    "name": "useEliteSeatProgressUpdatedAllLevelsQuery",
    "operationKind": "query",
    "text": "query useEliteSeatProgressUpdatedAllLevelsQuery {\n  eliteSealLevels {\n    name\n    tierStartUsd\n    tierStartLevel\n    tierStep\n    tierCount\n    bonusUsd\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d5c8e45b303cc618f955b1ec39efe58";

export default node;
